<template>
  <div>
    <Listbox v-model="selectedOption" v-slot="{ open }">
      <div class="relative mt-1">
        <ListboxButton class="list-box-button">
          <span class="block truncate" :class="[listButtonClasses]">
            {{ selectedOption.text }}
          </span>
          <span class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <transition name="mode-fade" mode="out-in">
              <ph-caret-up :size="18" v-if="open" />
              <ph-caret-down :size="18" v-else />
            </transition>
          </span>
        </ListboxButton>

        <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div v-show="open">
            <ListboxOptions class="list-box-options">
              <ListboxOption
                v-slot="{ active, selected }"
                v-for="option in options"
                :key="option.uuid"
                :value="option"
                as="template"
              >
                <li
                  :class="[
                    active ? 'text-white bg-black' : 'text-black',
                    'cursor-default select-none relative py-2 pl-10 pr-4',
                  ]"
                >
                  <span :class="[optionClasses(selected), 'block truncate']">{{ option.text }}</span>
                  <span v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-3">
                    <ph-check :size="18" weight="bold" />
                  </span>
                </li>
              </ListboxOption>
            </ListboxOptions>
          </div>
        </transition>
      </div>
    </Listbox>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { Listbox, ListboxLabel, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue'
import { PhCaretUp, PhCaretDown, PhCheck } from '@dnlsndr/vue-phosphor-icons'

const mockOptions = [
  {
    name: 'Wade Cooper Wade Wade Cooper Wade Wade Cooper Wade Wade Cooper Wade Wade Cooper Wade Wade Cooper Wade Wade Cooper Wade Wade Cooper Wade ',
  },
  { name: 'Arlene Mccoy' },
  { name: 'Devon Webb' },
  { name: 'Tom Cook' },
  { name: 'Tanya Fox' },
  { name: 'Hellen Schmidt' },
  { name: 'Wade Cooper Wade Cooper' },
  { name: 'Arlene Mccoy' },
  { name: 'Devon Webb' },
  { name: 'Tom Cook' },
  { name: 'Tanya Fox' },
  { name: 'Hellen Schmidt' },
]

export enum TypeListBox {
  normal = 'normal',
  bold = 'bold',
}

export default defineComponent({
  components: {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
  },

  props: {
    options: {
      // TODO: Missing type
      type: Array,
      default: () => mockOptions,
    },

    type: {
      type: String,
      default: TypeListBox.bold,
      validator(val: string) {
        return ['normal', 'bold'].includes(val)
      },
    },
  },

  setup(props: any, { emit }) {
    const { options, type } = props

    const selectedOption = ref(options[0])

    const optionClasses = (selected: Boolean) => {
      let classes = ''
      classes += selected && type == 'bold' ? 'font-bold ' : 'font-semibold '
      classes += selected ? 'font-semibold ' : 'font-semibold'

      return classes
    }

    const listButtonClasses = computed(() => {
      let classes = ''
      classes += type == 'bold' ? 'font-semibold' : 'font-regular'
      return classes
    })

    /**
     * @emits update:selectedItem
     * @event selectedOption
     */
    watch(selectedOption, () => {
      emit('update:selectedItem', [selectedOption.value.uuid])
    })
    /**
     * @emits update:selectedItem
     * @event selectedOption
     * innitial emit
     */
    onMounted(() => {
      emit('update:selectedItem', [selectedOption.value.uuid])
    })

    return {
      options,
      selectedOption,
      optionClasses,
      listButtonClasses,
      PhCaretUp,
      PhCaretDown,
      PhCheck,
    }
  },
})
</script>

<style scoped>
.list-box-button {
  @apply relative w-full py-1.5 pl-8 pr-9 text-left bg-white cursor-default border-solid border border-black focus:outline-none;
}

.list-box-options {
  @apply absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm;
}
.mode-fade-enter-active,
.mode-fade-leave-active {
  transition: opacity 0.2s ease;
}

.mode-fade-enter-from,
.mode-fade-leave-to {
  opacity: 0;
}
</style>
